import { Field, FieldLabel } from "@/components/ui/field";
import { Spinner } from "@/components/ui/spinner";
import { DynamicIntakeFields } from "./dynamic-intake-fields";
import { useIntakeMessages } from "./intake-messages";
import type { useTicketIntake } from "./use-ticket-intake";

export function TicketIntakeAdditionalFields({ form }: { form: ReturnType<typeof useTicketIntake> }) {
  const m = useIntakeMessages();
  const { session, values } = form;
  if (form.initializing) {
    return (
      <Field aria-busy="true">
        <FieldLabel>{m.business}</FieldLabel>
        <div role="status" className="flex items-center gap-2 text-sm text-muted-foreground">
          <Spinner />
          {m.loading}
        </div>
      </Field>
    );
  }
  if (!session || !values || !session.form.schema.fields.length) return null;
  return (
    <DynamicIntakeFields
      key={`${session.id}:${values.categoryId}:${session.form.formVersionId}`}
      schema={session.form.schema}
      values={values.fieldValues}
      context={values.context}
      disabled={form.busy}
      errors={form.errors}
      lookup={form.lookup}
      onChange={form.setField}
    />
  );
}
